import secondaryComponents from "../..";
import Images from "../../../../assets/images";

const ProductsList = ({
  products,
  handleAddToCart,
  cartItems,
  handleReduceCartItem,
  getCartItems = () => {},
  pricingType,
}) => {
  return (
    <>
      {products?.length > 0 ? (
        <>
          {products?.map((product, index) => (
            <div key={product?.id}>
              {product?.variants?.length > 0 ? (
                <secondaryComponents.ProductVariantCard
                  product={product}
                  key={product?.id}
                  handleAddToCart={handleAddToCart}
                  cartItems={cartItems}
                  handleReduceCartItem={handleReduceCartItem}
                  productIndex={index}
                  pricingType={pricingType}
                />
              ) : (
                <secondaryComponents.ProductCard
                  product={product}
                  key={product?.id}
                  cartDetails={getCartItems(product?.id)}
                  handleAddToCart={handleAddToCart}
                  handleReduceCartItem={handleReduceCartItem}
                  productIndex={index}
                  pricingType={pricingType}
                />
              )}
            </div>
          ))}
        </>
      ) : (
        <div style={{ marginTop: "100px" }} className="text-center">
          <img src={Images.productsEmptyState} alt="" width={"250px"} />
          <h5 className="mt-3 text-center">No data available</h5>
        </div>
      )}
    </>
  );
};

export default ProductsList;
